<template>
	<div class="c-field" :class="{'flex-start': !vertical, 'flex-column': vertical}">
		<label v-if="label" class="c-field-label">{{label}}：</label>
		<div class="c-field-content" :class="{'flex-grow': !vertical}" :style="{'margin-top': vertical ? '8px' : 0}"><slot></slot></div>
	</div>
</template>

<script>
	export default {
		name: 'cField',

		props: {
			label: String,
			vertical: Boolean
		}
	}
</script>

<style lang="stylus" scoped>
	.c-field {
		padding: 2px 0;
		line-height: 20px;
		font-size: 14px;
	}
</style>
